module.exports = __webpack_public_path__ + "static/media/ice26.b56b0eb9.webp";